import React from 'react';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  formSectionTab: {
    marginTop: 24,
  },
  // title: {
  //   opacity: 0.6,
  //   fontSize: "16px",
  //   fontWeight: "normal",
  //   lineHeight: 1.31,
  //   letterSpacing: "0.16px",
  //   color: "#000000",
  //   marginBottom: 21,
  // },
  buttonTab: {
    marginRight: 8,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0.25,
  },
}));

const FormTabs = ({ selectedScreen, setSelectedScreen, resetContent }) => {
  const classes = useStyles();

  return (
    <div className={classes.formSectionTab}>
      <div className={classes.formTab}>
        {/* <Typography classes={{ root: classes.title }}>
            Search job role to match talent with
          </Typography>
          <JobAutocomplete
            id={'id'}
            selectedJob={selectedJob}
            setSelectedJob={handleSelectedJob}
          /> */}
        <Button
          classes={{ root: classes.buttonTab }}
          variant={
            selectedScreen === 'BI_METRIC_SEMANTIC_MATCH_SCREEN'
              ? 'contained'
              : 'outlined'
          }
          color="primary"
          onClick={() => {
            resetContent();
            setSelectedScreen('BI_METRIC_SEMANTIC_MATCH_SCREEN');
          }}
        >
          Bi-Metric Semantic Match
        </Button>
        <Button
          classes={{ root: classes.buttonTab }}
          variant={
            selectedScreen === 'EXPLAINABLE_MATCH_SCREEN'
              ? 'contained'
              : 'outlined'
          }
          color="primary"
          onClick={() => {
            resetContent();
            setSelectedScreen('EXPLAINABLE_MATCH_SCREEN');
          }}
        >
          Explainable Match
        </Button>
      </div>
    </div>
  );
};

export default FormTabs;
